module.exports = __webpack_public_path__ + "img/light-frame.f20bffbe.png";